<script setup lang="ts">
const props = defineProps({
  title: {
    type: String,
    required: false,
  },
  percentage: {
    type: String,
    required: false,
    default: () => '0.0%',
  },
  infoNumber: {
    type: String,
    required: false,
    default: () => '0',
  },
  bgColor: {
    type: String,
    required: false,
    default: () => '#FC6161',
  },
  bgIconColor: {
    type: String,
    required: false,
    default: () => '#FFFFF',
  }
})
</script>

<template>
  <slot name="infoCard">
    <div class="card relative h-6rem border-round-xl p-3">
      <span v-if="props?.title" class="text-sm font-medium line-height-1 font-semibold"> {{ props.title }} </span>
      <div class="flex justify-content-between">
        <div class="flex justify-content-between align-items-center">
          <div v-if="false" class="flex justify-content-center align-items-center h-3rem w-3rem border-round mr-3" :style="{ background: props?.bgColor }" style="box-shadow: 0px 6px 20px rgba(252, 97, 97, 0.3)">
            <!-- <i class="pi pi-arrow-down w-2rem" /> -->
            <i class="pi pi-folder" style="font-size: 1.6rem" :style="{ color: props?.bgIconColor }" />
            <!-- <span v-if="props?.percentage" class="line-height-2">{{ props.percentage }}</span> -->
          </div>
          <div v-if="props?.infoNumber" class="line-height-4 text-4xl">
            {{ props?.infoNumber }}
          </div>
        </div>
      </div>
      <img class="absolute" style="bottom: 14px; right: 12px" src="/demo/images/ecommerce-dashboard/rate.svg">
    </div>
  </slot>
</template>
